<template>
  <!-- :bodyStyle="{paddingTop:'10px'}" -->
  <a-card :bordered="false" :headStyle="{borderBottom:'0px',fontSize:'18px',paddingLeft:'24px'}">
    <search-page-view
      ref="table"
      rowKey="couponId"
      :columns="columns"
      :enableSearch="false"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
      <a-form-item slot="operation">
        <a-input-search placeholder="请输入优惠券名称" @search="onSearch" style="max-width: 400px;"/>
        <a-button style="margin-left: 10px" type="primary" icon="plus" @click="createCodeEvent(0,0)">新建</a-button>
      </a-form-item>
      <template slot="timeSlots" slot-scope="data">
        <span>{{ data.record.couponGetStartTime }}至{{ data.record.couponGetEndTime }}</span>
      </template>
      <div slot="action" slot-scope="data">
        <a v-if="data.record.couponStatus==0"
           @click="createCodeEvent(data.record.couponId,data.record.couponStatus)">编辑</a>
        <a v-else @click="createCodeEvent(data.record.couponId,data.record.couponStatus)">查看</a>
        <span v-if="getDataShow(data.record.couponStatus)">
        <a-divider type="vertical"/>
        <a @click="goDataStatics(data.record.couponId)">统计</a>
      </span>
        <span v-if="getShareShow(data.record.couponStatus,data.record.couponGetWay)">
        <a-divider type="vertical"/>
        <a @click="openShare(data.record.couponId)">分享</a>
      </span>
      </div>
    </search-page-view>
    <a-modal title="分享" :visible="dialogVisible" width="800px" :footer="null" @cancel="handleCancel">
      <a-row>
        <a-col :span="11">
          <div class="img-top">
            <img v-if="ruleForm.shareBannerUrl" :src="ruleForm.shareBannerUrl" alt="">
            <img v-else src="https://imgb.woyoubooking.com/common/default_coupon-banner.png" alt="">
          </div>
          <div class="img-footer">
            <img v-if="footerUrl" :src="footerUrl" alt="">
            <img v-else src="https://imgb.woyoubooking.com/common/share-orange.jpg" alt="">
          </div>
        </a-col>
        <a-col :span="13">
          <a-form-model :model="ruleForm" ref="ruleForm"
                        :label-col="currentFormLayout.labelCol"
                        :wrapper-col="currentFormLayout.wrapperCol"
          >
            <a-form-model-item label="Banner图片" style="margin-bottom:0px">
              <a-upload
                name="avatar"
                listType="picture-card"
                class="avatar-uploader"
                :showUploadList="false"
                :action="uploadFileUrl"
                :beforeUpload="beforeUpload"
                @change="handleChange"
              >
                <img class="upload-img" v-if="ruleForm.shareBannerUrl" :src="ruleForm.shareBannerUrl" alt="avatar"/>
                <div v-else>
                  <div class="ant-upload-text">Upload</div>
                </div>
              </a-upload>
            </a-form-model-item>
            <a-form-model-item label="领取模式">
              <a-radio-group name="radioGroup" v-model="ruleForm.shareType">
                <a-radio :value="1">单劵领取</a-radio>
                <a-radio :value="2">多劵领取</a-radio>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="颜色背景:">
              <ul class="color-ul">
                <li v-for="(item,index) in colorList" :key="index" :class="item.label"
                    @click="onEventColor(item.label,item.url)"></li>
              </ul>
            </a-form-model-item>
            <a-form-model-item :wrapper-col="{ span: 14, offset: 6 }">
              <a-button type="primary" @click="handleSubmit" :loading="submitLoading">保存</a-button>
            </a-form-model-item>
            <div class="title-text">分享优惠券</div>
            <a-form-model-item label="小程序码" v-if="ruleForm.shareMinProgramUrl">
              <img class="w100" :src="ruleForm.shareMinProgramUrl" alt="">
            </a-form-model-item>
            <a-form-model-item label="分享链接">
              <a-textarea v-model="config.common.bdUrl" placeholder="分享链接" :rows="4" disabled/>
              <a-button @click="onCopy">复制链接</a-button>
              <BaiduShare :config="config" style="vertical-align: -37px;margin-left:10px;"></BaiduShare>
            </a-form-model-item>
          </a-form-model>
        </a-col>
      </a-row>
    </a-modal>
  </a-card>
</template>

<script>
import BaiduShare from '@/customComponents/BaiduShare/BaiduShare'
import { mapState } from 'vuex'
import RouterSwitchHelper from '@/utils/helper/RouterSwitchHelper'

export default {
  name: 'CouponServiceList',
  components: {
    BaiduShare
  },
  data() {
    return {
      uploadFileUrl: this.getUploadFileUrl(),
      submitLoading: false,
      currentFormLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      ruleForm: {
        shareBannerUrl: '',
        shareColor: '',
        shareCouponId: '',
        shareId: '',
        shareMinProgramUrl: '',
        shareType: 1
      },
      queryParams: {
        couponMerchantId: this.$store.getters.userInfo.merchantId,
        couponName: '', // 优惠券名称
        couponPlatformId: this.getPlatformConfig().platformId
      },
      loadPromise: params => this.getListPromise(params),
      columns: [
        {
          title: 'ID',
          dataIndex: 'couponId'
        },
        {
          title: '优惠券名称',
          dataIndex: 'couponName'
        },
        {
          title: '面额',
          dataIndex: 'couponAmout'
        },
        {
          title: '类型',
          dataIndex: 'couponUseTypeStr'
        },
        {
          title: '起止时间',
          dataIndex: 'couponGetStartTime',
          scopedSlots: { customRender: 'timeSlots' }
        },
        {
          title: '来源',
          dataIndex: 'couponSourceStr'
        },
        {
          title: '状态',
          dataIndex: 'couponStatusStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '160px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      dialogVisible: false,
      footerUrl: '',
      colorList: [
        {
          url: 'https://imgb.woyoubooking.com/common/share-orange.jpg',
          label: 'orange'
        },
        {
          url: 'https://imgb.woyoubooking.com/common/share-blue.jpg',
          label: 'blue'
        },
        {
          url: 'https://imgb.woyoubooking.com/common/share-purple.jpg',
          label: 'purple'
        },
        {
          url: 'https://imgb.woyoubooking.com/common/share-red.jpg',
          label: 'red'
        },
        {
          url: 'https://imgb.woyoubooking.com/common/share-skyblue.jpg',
          label: 'skyblue'
        }
      ],
      config: {
        common: {
          bdText: '',
          bdDesc: '',
          bdUrl: '',
          bdPic: '',
          bdSign: 'off'
        },
        share: [
          {
            bdSize: 24
          }
        ],
        image: [
          {
            viewType: 'list',
            viewPos: 'top',
            viewColor: 'black',
            viewSize: '16',
            viewList: ['qzone', 'tsina', 'huaban', 'tqq', 'renren']
          }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      // 获取版本
      vesion: state => state.config.serverDataInfo.vesion
    })
  },
  mounted() {

  },
  activated() {
    this.getLogUtils().logWithTag('优惠券activated')
    this.$store.commit('SET_RECHARGE', true)
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'CouponServiceList', title: '优惠券列表' },
      { name: 'CouponRuleList', title: '规则列表' }
    ])
    if (this.$route.query.updateFlag) {
      this.getLogUtils().logWithTag('activated', this.$route.query.updateFlag)
      this.$refs.table.refresh(true)
    }
  },
  methods: {
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getOrderListPromise==', params)
      return this.getHttpServices().getServerApiService().post('coupon/setting/getCouponSettingList', params)
    },
    //获取图片上传地址
    getUploadFileUrl() {
      let appConfig = this.getAppConfig()
      return appConfig.baseUrl + (appConfig.isDev ? '/' : '') + 'base/upload'
    },
    handleCancel() {
      this.dialogVisible = false
    },
    onSearch(value) {
      this.queryParams.couponName = value
      this.$refs.table.refresh(true)
    },
    // 新增内容
    createCodeEvent(couponId, status) {
      this.$router.push({
        name: 'NewCoupon',
        query: {
          couponId: couponId,
          status: status,
          serverUniqueId: this.$route.query.serverUniqueId
        }
      })
    },
    //去数据统计
    goDataStatics(couponId) {
      this.$router.push({
        name: 'CouponStatics',
        query: {
          couponId: couponId,
          serverUniqueId: this.$route.query.serverUniqueId
        }
      })
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.submitLoading = true
      this.getHttpServices().getServerApiService().post('coupon/setting/updateCouponSettingShare', this.ruleForm).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('保存成功')
        this.dialogVisible = false
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    //是否展示数据统计
    getDataShow(status) {
      if (this.vesion != 1 && status != 0) {
        return true
      } else {
        return false
      }
    },
    //是否展示分享
    getShareShow(status, way) {
      if (this.vesion == 3 && status == 1 && way == 2) {
        return true
      } else {
        return false
      }
    },
    //打开分享弹窗
    openShare(couponId) {
      this.dialogVisible = true
      this.getCouponSettingShare(couponId)
      this.getH5Url(couponId)
    },
    // 获取分享内容
    getCouponSettingShare(couponId) {
      this.getHttpServices().getServerApiService().post('coupon/setting/getCouponSettingShare/' + couponId).then(res => {
        this.getLogUtils().logWithTag('==getCouponSettingShare==', res)
        this.ruleForm = res
        this.getFooterImg(res.shareColor)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //获取底部图片
    getFooterImg(label) {
      let imgUlr = ''
      try {
        imgUlr = this.colorList.filter(item => {
          return item.label == label
        })[0].url
      } catch (err) {
        this.getLogUtils().logWithTag('错误', 'error submit!!')
      }
      this.footerUrl = imgUlr
    },
    // 图片上传
    handleChange(info) {
      this.getLogUtils().logWithTag('handleBeforeUploadImage', info)
      if (info.file.status === 'uploading') {
        return
      }
      if (info.file.status === 'done') {
        // Get this url from response in real world.
        if (info.file.response.status == 1) {
          this.$message.success('图片上传成功')
          this.ruleForm.shareBannerUrl = info.file.response.data
        } else {
          this.$message.error(info.file.response.msg)
        }
      } else if (status === 'error') {
        this.$message.error(`${info.file.name} 文件上传失败`)
      }
    },
    beforeUpload(file) {
      this.getLogUtils().logWithTag('handleBeforeUploadImage', file)
      // 限制图片 格式、size、分辨率
      const isJPG = file.type === 'image/jpeg'
      const isJPEG = file.type === 'image/jpeg'
      const isGIF = file.type === 'image/gif'
      const isPNG = file.type === 'image/png'
      if (!(isJPG || isJPEG || isGIF || isPNG)) {
        this.$message.error('上传图片的格式不正确，不是JPG、JPEG、GIF、PNG')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('上传的文件不能大于2M!')
        return false
      }
      return true
    },
    onEventColor(label, url) {
      this.footerUrl = url
      this.ruleForm.shareColor = label
    },
    //获取前端链接
    getH5Url(couponId) {
      let domainUrl = this.getAppConfig().platformConfig.h5Url
      const merchantId = this.$store.getters.userInfo.merchantId
      const character = 1
      let params = {
        p: `${character}_${merchantId}_${merchantId}`,
        id: encodeURIComponent('/?:@' + couponId + '&#=+$#')
      }
      let bdUrl = RouterSwitchHelper.getCouponSharePathUrl(domainUrl, params)
      this.config.common = Object.assign({}, this.config.common, {
        bdText: '优惠劵分享',
        bdDesc: '优惠劵分享',
        bdUrl: bdUrl
      })
    },
    onCopy() {
      this.$copyText(this.config.common.bdUrl).then(message => {
        this.getLogUtils().logWithTag('copy', message)
        this.$message.success('复制完毕')
      }).catch(err => {
        this.getLogUtils().logWithTag('copy.err', err)
        this.$message.error('复制失败')
      })
    }

  }

}
</script>
<style scoped lang="less">
.herder-set {
  text-align: right;
  float: right;

  a {
    padding-left: 10px;
  }
}

.img-top {
  height: 220px;

  img {
    width: 100%;
    height: 100%;
  }
}

.img-footer {
  height: 400px;

  img {
    width: 100%;
    height: 100%;
  }
}

.avatar-uploader > .ant-upload {
  width: 95px;
  height: 95px;
}

.upload-img {
  width: 95px;
  height: 95px;
}

.color-ul {
  display: flex;
  list-style: none;
  padding-inline-start: 0;

  li {
    width: 60px;
    height: 40px;
    margin-right: 10px;
    cursor: pointer;
    border-radius: 4px;
    list-style: none;
  }

  .orange {
    background-color: orange;
  }

  .blue {
    background-color: blue;
  }

  .purple {
    background-color: purple;
  }

  .red {
    background-color: red;
  }

  .skyblue {
    background-color: skyblue;
  }
}

.title-text {
  height: 26px;
  line-height: 26px;
  font-size: 16px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.65);
  padding-left: 15px;
}

.w100 {
  width: 100px;
  height: 100px;
}
</style>